var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuChinese(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_20406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z",
    fill: "#EE1C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5055 8.68363L10.769 8.67163L10.5295 7.97563L10.2905 8.67163L9.55401 8.68413L10.1425 9.12613L9.92701 9.82963L10.53 9.40713L11.133 9.82963L10.917 9.12613L11.5055 8.68363ZM8.80451 5.36313L8.81651 4.62663L9.51251 4.38713L8.81651 4.14763L8.80401 3.41113L8.36201 3.99963L7.65801 3.78463L8.08101 4.38763L7.65801 4.99063L8.36201 4.77413L8.80451 5.36313ZM8.80451 11.5881L8.81651 10.8516L9.51251 10.6121L8.81651 10.3726L8.80401 9.63613L8.36201 10.2246L7.65801 10.0096L8.08101 10.6126L7.65801 11.2156L8.36201 10.9991L8.80451 11.5881ZM10.8265 6.26813L11.1495 5.60663L10.488 5.92963L9.95851 5.41763L10.062 6.14613L9.41201 6.49163L10.1375 6.61913L10.265 7.34463L10.6095 6.69413L11.3385 6.79713L10.8265 6.26813ZM6.75551 6.60663L4.77001 6.57363L4.12451 4.69763L3.47951 6.57413L1.49451 6.60763L3.08101 7.80013L2.50001 9.69763L4.12551 8.55813L5.75151 9.69663L5.16951 7.79963L6.75551 6.60663Z",
    fill: "#FFFF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_20406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuChinese);
export default __webpack_public_path__ + "static/media/menuChinese.b05237402f6c86795988c5e06adbe60b.svg";
export { ForwardRef as ReactComponent };